import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import {
    RequirementItem,
    TFundingRequirementStatus
} from '../RequirementsList/RequirementItem/RequirementItem';

type TApplicantCallStepProps = { status: TFundingRequirementStatus };

export const ApplicantCallStep = ({ status }: TApplicantCallStepProps) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.applicant_call_step.title"
                    defaultMessage="Give us a quick call"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements.estimated_time"
                    defaultMessage="~ {minutes} mins"
                    values={{ minutes: 5 }}
                />
            }
            href="/funding-requirements/applicant-call"
            status={status}
            completedView={
                <Text className="font-med text-primary-10">
                    <FormattedMessage
                        id="_.funding_requirements.applicant_call_step.title"
                        defaultMessage="Give us a quick call"
                    />
                </Text>
            }
        />
    );
};
